import { useState } from 'react';
import { Typography } from 'antd';
import { SelectPlus } from 'Components/SelectPlus';
import { useGetMunicipalities } from '../hooks/useMunicipalities';
import { useDebounce } from '@shared/hooks/useDebounce';
import { getErrorMessage } from '@/shared/utils/errors/getErrorMessage';

const { Text } = Typography;

const VALUE_KEY_MAP = {
  id: 'ids',
  code: 'codes',
}

export const SelectMunicipality = ({ mode = 'single', valueKey = 'id', onSearch, ...selectProps }) => {
  const [searchText, setSearchText] = useState('');

  const selectedValues = (Array.isArray(selectProps.value) ? selectProps.value : [selectProps.value]).filter((item) => item !== null && item !== undefined);
  const queryData = searchText
    ? { searchText, pageSize: 130 } // Se usa pageSize: 130 para asegurar que, al buscar por departamento, se carguen todos sus municipios (el máximo actual es 125)
    : selectedValues.length > 0
      ? { [VALUE_KEY_MAP[valueKey]]: selectedValues, pageSize: selectedValues.length } // Al buscar por keys únicas seleccionadas, se ajusta pageSize para traer todos los registros de una vez
      : { pageSize: 10 }; // Por defecto se muestran 10 registros

  const { data, isFetching, isError, error } = useGetMunicipalities(queryData);

  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar municipio${isSingleMode ? '' : 's'}`;

  const records = data?.results ?? [];
  const options = records.map((record) => ({
    value: record[valueKey],
    label: <>{record.name} <Text type='secondary'>({record.departmentName})</Text></>,
    record,
  }));

  const debouncedSetSearchText = useDebounce(setSearchText);

  const handleSearch = (newSearchText) => {
    debouncedSetSearchText(newSearchText);
    onSearch?.(newSearchText);
  };

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      loading={isFetching}
      options={options}
      onSearch={handleSearch}
      filterOption={false} // Se desactiva filtrado interno, ya que se maneja manualmente
      error={isError}
      errorMessage={getErrorMessage(error)}
      {...selectProps}
    />
  );
};